{
  "title": "Storm of Vengeance",
  "source": "Player's Handbook",
  "levelAndSchool": "9th-level conjuration",
  "level": 9,
  "castingTime": "1 action",
  "range": "Sight",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "A churning storm cloud forms, centered on a point you can see and spreading to a radius of 360 feet. Lightning flashes in the area, thunder booms, and strong winds roar. Each creature under the cloud (no more than 5,000 feet beneath the cloud) when it appears must make a Constitution saving throw. On a failed save, a creature takes 2d6 thunder damage and becomes deafened for 5 minutes.",
    "Each round you maintain concentration on this spell, the storm produces different effects on your turn.",
    "Storm of Vengeance After Round 1",
    "Round",
    "Effect",
    "2",
    "Acidic rain falls from the cloud. Each creature and object under the cloud takes 1d6 acid damage.",
    "3",
    "You call six bolts of lightning from the cloud to strike six creatures or objects of your choice beneath the cloud. A given creature or object can’t be struck by more than one bolt. A struck creature must make a Dexterity saving throw. The creature takes 10d6 lightning damage on a failed save, or half as much damage on a successful one.",
    "4",
    "Hailstones rain down from the cloud. Each creature under the cloud takes 2d6 bludgeoning damage.",
    "5-10",
    "Gusts and freezing rain assail the area under the cloud. The area becomes difficult terrain and is heavily obscured. Each creature there takes 1d6 cold damage. Ranged weapon attacks in the area are impossible. The wind and rain count as a severe distraction for the purposes of maintaining concentration on spells. Finally, gusts of strong wind (ranging from 20 to 50 miles per hour) automatically disperse fog, mists, and similar phenomena in the area whether mundane or magical."
  ],
  "spellLists": ["druid"]
}
